export interface BouncedEmailModel {
  id: number;
  domainType: string;
  email: string;
  typeId: number;
  typeName: string;
  activityId: number;
  activityName: string;
  reason: string;
  // custom server id, 0 for the system mail server, null for a legacy row (blocks every server)
  mailServerId?: number | null;
  mailServerFrom?: string;
  createdBy: string;
  createdDate: Date;
}
